import { createSlice } from '@reduxjs/toolkit';
export const initialState = {};
export const ProposeNewTimeSlice = createSlice({
    name: 'propose-newtime-scheduling',
    initialState,
    reducers: {
        proposeNewTime(_state, _action) {
            // No-op implementation for initial state
        },
        fetchBusySlots(_state, _action) {
            // No-op implementation for initial state
        },
        storeBusySlots(_state, _action) {
            // No-op implementation for initial state
        },
    },
});
export const { storeBusySlots, proposeNewTime, fetchBusySlots } = ProposeNewTimeSlice.actions;
export default ProposeNewTimeSlice.reducer;
